export default "__VITE_ASSET__7f008dd5__"